// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './CustmizeRingDiamondOptionPrice.style';
import Link from '@scandipwa/scandipwa/src/component/Link';
import DiamondIcon from 'Component/DiamondIcon/DiamondIcon.component';
import DiamondImage from 'Component/DiamondImage';
import { GQLCurrencyEnum } from '@scandipwa/scandipwa/src/type/Graphql.type';

export class CustmizeRingDiamondOptionPrice extends PureComponent {
    static propTypes = {
        product: this.propTypes,
        showoptions: this.propTypes
    };

    state = {
        changeoptions: false,
    }

    handleRemove(categories) {
        if (JSON.parse(localStorage.getItem("diamond"))) {
            localStorage.setItem("step", "Diamond");
        } else {
            localStorage.setItem("step", "Setting");
        }

        this.setState({
            changeoptions: true
        });
    }

    render() {
        const { product, showoptions } = this.props;
        const { categories } = product;

        const currencySymbol = GQLCurrencyEnum.USD;

        const pricewithcurrency = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencySymbol,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(Math.round(product.diamond_price).toFixed(0));

        const viewlink = `/view_diamond?diamond_sku=${product.diamond_sku}`;
        const changelink = product?.hasColor ? "/coloreddiamond?diamond_created_from=11" : "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11";

        return (
            <div className="CustmizeRingDiamondOptionPrice">
                <div className="CustmizeRingOptionPrice">
                    {
                        showoptions ?
                            this.state.changeoptions ? <DiamondIcon /> :
                                <div className='ring-option'>
                                    <div className='ring-option-container'>
                                        <div aria-label={`Product price: ${product.diamond_price}`} className="ProductPrice   ProductPrice-Price">
                                            <span className="ProductPrice-Price">
                                                <span className="ProductPrice-PriceValue">
                                                    {pricewithcurrency}
                                                </span>
                                            </span>
                                        </div>
                                        <div className='view-remove-option-container'>
                                            <Link
                                                block="CustmizeRingOptionPrice"
                                                elem="viewoption"
                                                to={viewlink}
                                            >
                                                <span>view</span>
                                            </Link>
                                            <span>&nbsp;|&nbsp;</span>
                                            <Link
                                                block="CustmizeRingOptionPrice"
                                                elem="viewoption"
                                                to={changelink}
                                                onClick={() => this.handleRemove(categories)}
                                            >
                                                <span>change</span>
                                            </Link>
                                        </div>
                                    </div>
                                    <DiamondImage diamond_shape={product?.diamond_shape} image_url={product?.image_url} />
                                </div>
                            : <div aria-label={`Product price: ${product.diamond_price}`} className="ProductPrice ProductPrice-Price">
                                <span className="ProductPrice-Price">
                                    <span className="ProductPrice-PriceValue">
                                        {pricewithcurrency}
                                    </span>
                                </span>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default CustmizeRingDiamondOptionPrice;
